"use strict";
/**
 * Created by rouven on 13.06.17.
 */
exports.__esModule = true;
exports.STEP_FORWARD_PRESERVING_ERRORS = exports.SET_ERROR = exports.STEP_BACK = exports.STEP_FORWARD = exports.DESTROY = exports.INITIALIZE = void 0;
var PREFIX = '@@wikom-wizard/';
exports.INITIALIZE = PREFIX + 'INITIALIZE';
exports.DESTROY = PREFIX + 'DESTROY';
exports.STEP_FORWARD = PREFIX + 'STEP_FORWARD';
exports.STEP_BACK = PREFIX + 'STEP_BACK';
exports.SET_ERROR = PREFIX + 'SET_ERROR';
exports.STEP_FORWARD_PRESERVING_ERRORS = PREFIX + 'STEP_FORWARD_PRESERVING_ERRORS';
